var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8186 6.23738L8.31875 0.113356C8.13375 -0.0377853 7.86585 -0.0377853 7.68086 0.113356L0.181087 6.23738C-0.0316094 6.411 -0.0612089 6.72176 0.114988 6.93147C0.291085 7.14107 0.606379 7.17045 0.818976 6.99664L2.20005 5.86894V13.507C2.20005 13.7793 2.42385 14 2.70004 14H13.2999C13.5761 14 13.7998 13.7793 13.7998 13.507V5.86894L15.1809 6.99664C15.2743 7.07285 15.3872 7.10992 15.4996 7.10992C15.6434 7.10992 15.7861 7.04909 15.885 6.93137C16.0612 6.72166 16.0316 6.4109 15.8189 6.23728L15.8186 6.23738ZM9.39983 13.0142H6.59987V8.68719H9.39983V13.0142ZM12.7998 13.0142H10.3998V8.19423C10.3998 7.92202 10.176 7.70127 9.89982 7.70127H6.09988C5.82369 7.70127 5.59989 7.92202 5.59989 8.19423V13.0142H3.19993V5.05251L7.99985 1.13319L12.7998 5.05251V13.0142Z",
    fill: "#EF7C32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.367631179f4554e66b78f1f6b0fa1b3b.svg";
export { ForwardRef as ReactComponent };